// extracted by mini-css-extract-plugin
export var header = "_u7-1";
export var maskBottom = "_u7-6";
export var maskMiddle = "_u7-7";
export var maskTop = "_u7-5";
export var root = "_u7-0";
export var scrollDownButton = "_u7-3";
export var scrollDownButtonHidden = "_u7-4";
export var viewport = "_u7-2";